import React from 'react'
import { DashboardLayout } from '../../layouts'
import { Breadcrumb } from '../../components'
import { Form } from './components'
import { setMilestone } from '../../features/organization-form/slice'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { useViewport } from '../../utils'

const routes = [
  {
    name: 'Dashboard',
    route: '/dashboard'
  },
  {
    name: 'Organization Profile',
    route: '/dashboard/organization/profile'
  },
  {
    name: 'Milestones',
    route: '/dashboard/organization/profile/milestones'
  }
]

const DashboardMilestonesForm = ({ match }) => {
  const dispatch = useDispatch()
  const organizationForm = useSelector(state => state.organizationForm.data)
  const status = useSelector(state => state.organization.status)
  const id = match.params.id
  const isEdit = id
  const { isDesktop } = useViewport()

  React.useEffect(() => {
    if(id){
      const milestone = organizationForm.milestones.find(m => m.id === id)
      if(milestone){
        dispatch(setMilestone(milestone))
      }
    }
    // eslint-disable-next-line
  }, [id])

  const isNeedToFetchOrganization = status === 'idle'

  return isNeedToFetchOrganization ? (
    <Redirect to="/dashboard/organization/profile/milestones" />
  ) : (
    <DashboardLayout title="Edit Milestone">
      {
        isDesktop &&
        <div>
          <Breadcrumb routes={routes}/>
          <h1 className="text-4xl font-bold font-primary">
            {id ? 'Edit' : 'Create'} Milestone
          </h1>
          <hr className="mt-5 mb-8"/>
        </div>
      }
      <div className="lg:w-2/3">
        <Form isEdit={isEdit}/>
      </div>
    </DashboardLayout>
  )
}

export { DashboardMilestonesForm }
